import { css } from "styled-components";
import { ThemeProp } from "styles/theme";

export const drawerStyles = css`
  .ant-col {
    color: ${({ theme }: ThemeProp) => theme.textInLight};
  }
  .ant-drawer-content-wrapper[style] {
    // width: 50vw !important;
    // min-width: 900px;
    background: ${({ theme }: ThemeProp) => theme.emptyBackground};
  }
  .ant-drawer-body {
    background: ${({ theme }: ThemeProp) => theme.emptyBackground};
    color: ${({ theme }: ThemeProp) => theme.textInLight};
  }

  .ant-drawer-wrapper-body {
    background: ${({ theme }: ThemeProp) => theme.emptyBackground};
    color: ${({ theme }: ThemeProp) => theme.textInLight};

    *,
    .ant-drawer-title {
      &:not(
          span,
          .ant-input,
          .ant-select-selector,
          .ant-select,
          .ant-form-item,
          .ant-input-number,
          .prevent-color-propagation
        ) {
        color: inherit;
      }
    }

    .ant-collapse > .ant-collapse-item > .ant-collapse-header,
    .ant-input-number-group .ant-input-number-group-addon:last-child {
      color: ${({ theme }: ThemeProp) => theme.textInLight};
    }

    .ant-slider-rail {
      background: ${({ theme }: ThemeProp) => theme.textInLight};
    }

    .ant-drawer-body {
      padding-top: 0;
    }
  }
`;
